import { useState, useEffect } from "react";
import { singletonHook } from "react-singleton-hook";
import API from './api';

// const [useMyData, updateMyData] = createSingleton({});

const init = {
  token: null,
  error: null,
  user: null,
  isBusy: true,
  isReady: false,
};

const useLoginHook = () => {
  const [token, setToken] = useState(null);
  const [error, setError] = useState(null)
  const [isBusy, setIsBusy] = useState(true)
  const [user, setUser] = useState(null)
  const [isReady, setIsReady] = useState(false)

  useEffect(() => {
    const fetchUserData = async () => {
      const config = {
        headers: {
          Authorization: storedToken
        }
      }
      let res
      try {
        res = await API.get('auth/me', config)
      } catch (err) {
        console.log(err)
      }

      if (res?.status === 200) {
        setUser(res.data.userData)
        setIsBusy(false)
        setError(null)
        setIsReady(true)
      } else {
        emptyInfo()
      }


    }
    const emptyInfo = () => {
      setIsBusy(false)
      setUser(null)
      setError(null)
      setToken(null)
      setIsReady(true)
    }

    setIsBusy(true)
    const storedToken = localStorage.getItem('token');
    setToken(storedToken !== null ? storedToken : null);

    if (storedToken) fetchUserData()
    else emptyInfo()


  }, []);

  const logout = () => {
    localStorage.removeItem('token')
    setToken(null)
    setUser(null)
    setError(null)
    setIsBusy(false)
  }

  const login = async (email, password, onSuccess) => {
    setIsBusy(true)

    let res
    try {
      res = await API.post('auth/login', {
        email,
        password,
      }, {
        validateStatus: () => true,
      })
    } catch (err) {
      console.log(err)
    }

    if (res?.status === 404) {
      setError('Usuario no existe')
    } else if (res?.status === 403) {
      setError('Contraseña Incorrecta')
    } else if (res?.status === 200) {
      setError(null)
      setUser(res.data.userData)
      setToken(res.data.token)
      localStorage.setItem('token', res.data.token)
      if (onSuccess) onSuccess()
    } else {
      setError('Error Desconocido. Intente más tarde.')
    }

    setIsBusy(false)
  }

  const register = async (displayName, email, password, onSuccess) => {
    setIsBusy(true)

    let res
    try {
      res = await API.post('auth/register', {
        displayName,
        email,
        password,
      }, {
        validateStatus: () => true,
      })
    } catch (err) {
      console.log(err)
    }
    console.log(res)

    if (res?.status === 404) {
      setError('Error desconocido')
    } else if (res?.status === 403) {
      console.error(res)
      switch (res?.data?.code) {
        case "INVALID_EMAIL":
          setError('Correo electrónico inválido')
          break;
        case "INVALID_NAME":
          setError('Nombre de Usuario inválido')
          break;
        case "INVALID_PASSWORD":
          setError('Contraseña inválida')
          break;
        case "USER_ALREADY_EXISTS":
          setError('Ya existe un usuario con ese correo electrónico')
          break;
        default:
          setError('Error desconocido. Revisa tu conexión a internet o consulta con la administración.')
          break;
      }
      setError('Correo electrónico o Nombre de Usuario inválidos')
    } else if (res?.status === 200) {
      setError(null)
      setUser(res.data.userData)
      setToken(res.data.token)
      localStorage.setItem('token', res.data.token)
      if (onSuccess) onSuccess()
    } else {
      setError('Error Desconocido. Intente más tarde.')
    }

    setIsBusy(false)
  }

  return {
    token,
    error,
    login,
    register,
    logout,
    isBusy,
    isReady,
    user,
  };
};

const useLogin = singletonHook(init, useLoginHook);

export default useLogin;
